import "@dxos/node-std/globals"

// packages/common/crypto/src/encrypt.ts
import CryptoJS from "crypto-js";
import assert from "@dxos/node-std/assert";
var encrypt = (plaintext, passphrase, cipher = "AES") => {
  assert(typeof passphrase === "string");
  assert(typeof cipher === "string");
  return CryptoJS[cipher].encrypt(plaintext, passphrase).toString();
};
var decrypt = (ciphertext, passphrase, cipher = "AES") => {
  assert(typeof ciphertext === "string");
  assert(typeof passphrase === "string");
  assert(typeof cipher === "string");
  const bytes = CryptoJS[cipher].decrypt(ciphertext, passphrase);
  return bytes.toString(CryptoJS.enc.Utf8);
};

// packages/common/crypto/src/hash.ts
import CryptoJS2 from "crypto-js";
import assert2 from "@dxos/node-std/assert";
var _hash = (algorithm, plaintext) => {
  assert2(typeof algorithm === "string");
  assert2(typeof plaintext === "string");
  return CryptoJS2[algorithm](plaintext).toString();
};
var sha1 = (text) => _hash("SHA1", text);
var sha256 = (text) => _hash("SHA256", text);
var sha512 = (text) => _hash("SHA512", text);
var ripemd160 = (text) => _hash("RIPEMD160", text);

// packages/common/crypto/src/keys.ts
import crypto2 from "hypercore-crypto";
import assert3 from "@dxos/node-std/assert";
import { PublicKey, PUBLIC_KEY_LENGTH, SECRET_KEY_LENGTH } from "@dxos/keys";
var createId = () => PublicKey.stringify(randomBytes(32));
var SIGNATURE_LENGTH = 64;
var zeroKey = () => new Uint8Array(32);
var createKeyPair = (seed) => {
  if (seed) {
    assert3(seed.length >= 32, "Seedphrase too sort. Expecting length of 32.");
    return crypto2.keyPair(seed.slice(0, 32));
  }
  return crypto2.keyPair();
};
var validateKeyPair = (publicKey, secretKey) => crypto2.validateKeyPair({
  publicKey: publicKey.asBuffer(),
  secretKey
});
var discoveryKey = (key) => crypto2.discoveryKey(PublicKey.from(key).asBuffer().slice(1));
var randomBytes = (length = 32) => crypto2.randomBytes(length);
var sign = (message, secretKey) => {
  assert3(Buffer.isBuffer(message));
  assert3(Buffer.isBuffer(secretKey) && secretKey.length === SECRET_KEY_LENGTH);
  return crypto2.sign(message, secretKey);
};
var verify = (message, signature, publicKey) => {
  assert3(Buffer.isBuffer(message));
  assert3(Buffer.isBuffer(signature) && signature.length === SIGNATURE_LENGTH);
  assert3(Buffer.isBuffer(publicKey) && publicKey.length === PUBLIC_KEY_LENGTH);
  return crypto2.verify(message, signature, publicKey);
};

// packages/common/crypto/src/browser/subtle.ts
var subtleCrypto = crypto.subtle;

// packages/common/crypto/src/validator.ts
import { verify as verify2 } from "hypercore-crypto";
import { PublicKey as PublicKey2 } from "@dxos/keys";
var getSignatureValidator = (publicKey) => (message, signature) => verify2(message, signature, PublicKey2.bufferize(publicKey));

// packages/common/crypto/src/verify.ts
var verifySignature = async (key, message, signature) => {
  let publicKey;
  try {
    publicKey = await subtleCrypto.importKey("raw", key.asUint8Array(), {
      name: "ECDSA",
      namedCurve: "P-256"
    }, true, [
      "verify"
    ]);
  } catch (e) {
    return false;
  }
  return subtleCrypto.verify({
    name: "ECDSA",
    hash: "SHA-256"
  }, publicKey, signature, message);
};
export {
  SIGNATURE_LENGTH,
  createId,
  createKeyPair,
  decrypt,
  discoveryKey,
  encrypt,
  getSignatureValidator,
  randomBytes,
  ripemd160,
  sha1,
  sha256,
  sha512,
  sign,
  subtleCrypto,
  validateKeyPair,
  verify,
  verifySignature,
  zeroKey
};
//# sourceMappingURL=index.mjs.map
